import React from "react";

export default function Google(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.483"
      height="34.483"
      viewBox="0 0 34.483 34.483"
    >
      <g
        id="Google_logo"
        data-name="Google logo"
        transform="translate(-39 -554.713)"
      >
        <g id="facebook" transform="translate(39 554.713)">
          <circle
            id="Ellipse_20"
            data-name="Ellipse 20"
            cx="17.241"
            cy="17.241"
            r="17.241"
            transform="translate(0 0)"
            fill="#fff"
          />
        </g>
        <g id="google" transform="translate(44.5 561)">
          <path
            id="Path_70"
            data-name="Path 70"
            d="M5.273,107.061a5.94,5.94,0,0,1,.841-3.053v-3.793H2.321a11.256,11.256,0,0,0,0,13.692H6.114v-3.793A5.94,5.94,0,0,1,5.273,107.061Z"
            transform="translate(0 -95.811)"
            fill="#fbbd00"
          />
          <path
            id="Path_71"
            data-name="Path 71"
            d="M198.637,373.8,196,376.434l2.637,2.637a11.165,11.165,0,0,0,6.846-2.321v-3.789h-3.789A5.976,5.976,0,0,1,198.637,373.8Z"
            transform="translate(-187.387 -356.571)"
            fill="#0f9d58"
          />
          <path
            id="Path_72"
            data-name="Path 72"
            d="M56.616,325.477l-3.793,3.793a11.43,11.43,0,0,0,.974,1.109,11.176,11.176,0,0,0,7.955,3.3V328.4a5.979,5.979,0,0,1-5.136-2.923Z"
            transform="translate(-50.502 -311.174)"
            fill="#31aa52"
          />
          <path
            id="Path_73"
            data-name="Path 73"
            d="M267.25,199.9a11.346,11.346,0,0,0-.184-2.038l-.1-.54H256V202.6h5.337a5.95,5.95,0,0,1-2.28,2.445l3.789,3.789a11.427,11.427,0,0,0,1.109-.974A11.176,11.176,0,0,0,267.25,199.9Z"
            transform="translate(-244.75 -188.653)"
            fill="#3c79e6"
          />
          <path
            id="Path_74"
            data-name="Path 74"
            d="M202.863,7.024l.466.466,3.729-3.729-.466-.466A11.176,11.176,0,0,0,198.637,0L196,2.637l2.637,2.637A5.938,5.938,0,0,1,202.863,7.024Z"
            transform="translate(-187.387)"
            fill="#cf2d48"
          />
          <path
            id="Path_75"
            data-name="Path 75"
            d="M61.751,5.273V0A11.177,11.177,0,0,0,53.8,3.3,11.419,11.419,0,0,0,52.822,4.4L56.615,8.2A5.979,5.979,0,0,1,61.751,5.273Z"
            transform="translate(-50.501 0)"
            fill="#eb4132"
          />
        </g>
      </g>
    </svg>
  );
}
